import { render, staticRenderFns } from "./vuex-form.vue?vue&type=template&id=3d34a2e1&scoped=true"
import script from "./vuex-form.vue?vue&type=script&lang=js"
export * from "./vuex-form.vue?vue&type=script&lang=js"
import style0 from "./vuex-form.vue?vue&type=style&index=0&id=3d34a2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d34a2e1",
  null
  
)

export default component.exports